import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Button, Card, CardBody, Input } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faBullhorn } from '@fortawesome/free-solid-svg-icons'
import Flex from '../../common/Flex'
import CopyButton from '../../rewards/components/CopyButton'
import useCopy from '../../rewards/useCopy'

// Mensaje para que el administrador anuncie el programa a sus propietarios.
// Los valores (día límite, HC por dólar) vienen de la API porque son reglas
// que root puede cambiar sin despliegue (HO-TASK-276).
export const buildProgramMessage = ({ condominiumName, deadlineDay, hcPerUsd }) =>
  `Vecinos de ${condominiumName || 'nuestro condominio'}: ya pueden ganar premios por pagar su cuota a tiempo con Homelan Rewards.\n\n` +
  `• Cada pago aprobado en Homelan les da puntos (XP) para subir de nivel y Homelan Coins.\n` +
  `• Si pagan antes del día ${deadlineDay} reciben un bono extra, y pagando a tiempo varios meses seguidos ganan más Coins.\n` +
  `• Con sus Coins pueden abonar a su próxima cuota: ${hcPerUsd} Homelan Coins = $1.\n\n` +
  'Entren a Homelan y abran "Homelan Rewards" en el menú para ver su nivel y sus Coins.'

const ProgramShareCard = ({ condominiumName, deadlineDay, hcPerUsd }) => {
  const { copied, copy } = useCopy()
  const textarea = useRef(null)
  const message = buildProgramMessage({ condominiumName, deadlineDay, hcPerUsd })

  return (
    <Card className="mb-3">
      <CardBody>
        <Flex align="center" className="mb-2">
          <FontAwesomeIcon icon={faBullhorn} className="text-primary mr-2" />
          <h5 className="mb-0">Cuéntaselo a tus propietarios</h5>
        </Flex>
        <p className="fs--1 text-600 mb-3">
          Mientras más propietarios conozcan el programa, más pagos puntuales. Comparte este mensaje en el grupo del
          condominio o publícalo en{' '}
          <Link to="/dashboard/release" className="font-weight-semi-bold">
            Comunicados
          </Link>
          .
        </p>
        <Input
          type="textarea"
          innerRef={textarea}
          value={message}
          readOnly
          rows={7}
          className="fs--1 mb-3"
          aria-label="Mensaje para los propietarios"
        />
        <Flex className="flex-wrap">
          <div className="mr-2 mb-2">
            <CopyButton copied={copied === 'message'} onClick={() => copy('message', message, textarea.current, 'Mensaje copiado al portapapeles.')}>
              Copiar mensaje
            </CopyButton>
          </div>
          <Button
            tag="a"
            href={`https://wa.me/?text=${encodeURIComponent(message)}`}
            target="_blank"
            rel="noopener noreferrer"
            color="success"
            size="sm"
            className="mb-2 text-nowrap"
          >
            <FontAwesomeIcon icon={faWhatsapp} className="mr-1" />
            Compartir por WhatsApp
          </Button>
        </Flex>
      </CardBody>
    </Card>
  )
}

ProgramShareCard.propTypes = {
  condominiumName: PropTypes.string,
  deadlineDay: PropTypes.number.isRequired,
  hcPerUsd: PropTypes.number.isRequired
}

export default ProgramShareCard
